import t from '~/scopes/campaign/data/metals/manganese.translations'
import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['ieaGcmo2025'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['ieaGcmo2025', 'pblEnvironmental2024', 'pblSocial2025'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['pblSocial2025'],
  },
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: ['ademe2024', 'ieaGcmo2025', 'pblEnvironmental2024'],
      },
      blocks: [
        {
          title: SECTIONS.environmentalWater,
          text: t.envWaterText,
          sourceRefs: ['pblEnvironmental2024', 'pblSocial2025'],
        },
        {
          title: SECTIONS.environmentalClimate,
          text: t.envClimateText,
          sourceRefs: ['pblEnvironmental2024'],
        },
      ],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['pblSocial2025'],
      },
      blocks: [
        {
          title: SECTIONS.humanWaterRights,
          text: t.humanWaterText,
          sourceRefs: ['pblSocial2025'],
        },
        {
          title: SECTIONS.humanHealth,
          text: t.humanHealthText,
          sourceRefs: ['pblSocial2025'],
        },
        {
          title: SECTIONS.humanGender,
          text: t.humanGenderText,
          sourceRefs: ['pblSocial2025'],
        },
        {
          title: SECTIONS.humanLegal,
          text: t.humanLegalText,
          sourceRefs: ['pblSocial2025'],
        },
      ],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['ieaGcmo2025'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025', 'ieaGcmo2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['ieaGcmo2025', 'pblSocial2025'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['ieaGcmo2025'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['ieaGcmo2025'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['usgsMcs2025'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: ['usgsMcs2025', 'ieaGcmo2025'],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['ademe2024', 'chenManganese2026'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingInput,
        text: t.recyclingInputText,
      },
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: ['chenManganese2026'],
      },
    ],
  },
  mine0Region: t.mine0Region,
  mine1Region: t.mine1Region,
  mine2Region: t.mine2Region,
} as const
